import React, { useEffect } from 'react';
import "./NewCollections.css";
import Item from "../Items/Item";
import { useProductStore } from "../../stores/useProductStores";

const NewCollections = () => {
  const { newProducts, getNewCollections } = useProductStore();

  useEffect(() => {
    getNewCollections(); // Fetch new collections on mount
  }, [getNewCollections]);

  console.log("Rendered products:", newProducts);

  return (
    <div className="new-collections">
      <h1>NEW COLLECTION</h1>
      <hr />
      <div className="ccollections">
      {newProducts.length > 0 ? (
  [...newProducts]
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // newest first
    .slice(0, 8) // take first 8 newest
    .map((item, i) => (
      <Item
        key={item.id || i}
        id={item.id}
        name={item.name}
        image={item.image}
        price={item.price}
        availableQuantity={item.available_quantity}
      />
    ))
) : (
  <p>Loading new collection...</p>
)}
      </div>
    </div>
  );
};

export default NewCollections;
